/**
 * Shared types for audio player components
 */

/**
 * Player connection status
 */
export type PlayerStatus =
  | "idle"
  | "connecting"
  | "connected"
  | "error"
  | "disconnected";

/**
 * Common return type for player hooks
 */
export interface PlayerHookReturn {
  status: PlayerStatus;
  error: Error | null;
  retryCount: number;
  setVolume: (volume: number) => void;
}

/**
 * Squawk transport player names, in global fallback priority order: WebRTC
 * (lowest latency) → v2 (WebSocket + MSE via the audio-v2 backend; tolerates the
 * corporate firewalls that kill WebRTC's UDP consent traffic) → MSE (Flussonic) →
 * Shoutcast (most compatible, last — the most proxy-/UDP-tolerant safety net:
 * plain <audio>, no WebSocket upgrade, no MSE pipeline). Single source of truth
 * for the orchestrator's auto-fallback chain (SquawkPlayerContext) and the
 * Troubleshooting page's up/downgrade copy.
 */
export const PLAYER_PRIORITY = ["webrtc", "v2", "mse", "shoutcast"];
